import { Controller, useFormContext } from 'react-hook-form';
import { Modal } from 'shared-ui';

import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { Input } from 'ui/input/Input';

import { AddOrganizationItemProps, AddOrganizationItemFormBody } from './AddOrganizationItem.types';
import * as Styled from './AddOrganizationItem.styles';

export const AddOrganizationItem = ({ onSubmit, isModalOpen, onModalClose, isLoading }: AddOrganizationItemProps) => {
  const { formatMessage } = useLocale();
  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useFormContext<AddOrganizationItemFormBody>();

  return (
    <>
      <Modal
        header={formatMessage({ id: AppMessages['definitions.organization.add.title'] })}
        open={isModalOpen}
        onClose={onModalClose}
        type="form"
        onSubmit={handleSubmit(onSubmit)}
        submitButtonDisabled={!isValid || isLoading}
      >
        <Styled.Wrapper>
          <Controller
            name="kod"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <Input
                {...field}
                onChange={(e) => {
                  const valueWithoutSpaces = e.target.value.replace(/\s/g, '');
                  field.onChange(valueWithoutSpaces);
                }}
                label={formatMessage({ id: AppMessages['definitions.organization.add.code.label'] })}
                placeholder={formatMessage({ id: AppMessages['definitions.organization.add.code.placeholder'] })}
                errorMessage={error?.message}
                required
              />
            )}
          />

          <Controller
            name="nazwa"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <Input
                {...field}
                label={formatMessage({ id: AppMessages['definitions.organization.add.name.label'] })}
                placeholder={formatMessage({ id: AppMessages['definitions.organization.add.name.placeholder'] })}
                errorMessage={error?.message}
                required
              />
            )}
          />
        </Styled.Wrapper>
      </Modal>
    </>
  );
};
